"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_regex_validator_1 = require("../create-regex-validator");
var messages_1 = require("../messages");
var VAT_NUMBER_REGEX = /^\d{9}$/;
exports.validVATNumber = create_regex_validator_1.createRegexValidator(VAT_NUMBER_REGEX, messages_1.INVALID_VAT_NUMBER);
